import Card from "./Card";
import "./StatCard.scss";

/** 环比变化：方向 + 文案（如 "12.5% vs last month"） */
export interface StatDelta {
  direction: "up" | "down";
  text: string;
}

/** 顶部统计卡片：大数值 + 说明文案（可选环比/辅助说明） */
const StatCard: React.FC<{
  value: string;
  label: string;
  /** 数值颜色变体：accent（默认橙）或 primary（深色） */
  variant?: "accent" | "primary";
  loading?: boolean;
  /** 环比变化（涨=绿、跌=红）；无数据可不传 */
  delta?: StatDelta;
  /** 中性辅助说明（如 "Avg. 42/day"）；无数据可不传 */
  hint?: string;
}> = ({ value, label, variant = "accent", loading, delta, hint }) => {
  const valueClass = [
    "cs-stat__value",
    variant === "primary" ? "cs-stat__value--primary" : "",
    loading ? "cs-stat__value--loading" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Card>
      <div className={valueClass}>{loading ? "—" : value}</div>
      <div className="cs-stat__label">{label}</div>
      {!loading && delta && (
        <div className={`cs-stat__delta cs-stat__delta--${delta.direction}`}>
          {delta.direction === "up" ? "↑" : "↓"} {delta.text}
        </div>
      )}
      {!loading && !delta && hint && <div className="cs-stat__hint">{hint}</div>}
    </Card>
  );
};

export default StatCard;
